import { useState } from "react";
import "./anatabs.css";

const AnalysisTabsComponent = ({ dataMap, onChange }) => {
  const [currentTab, setCurrentTab] = useState(0);

  const tabList = Object.entries(dataMap).map(([key, label]) => ({
    key,
    label,
  }));

  return (
    <div className="circle-tabs" role="tablist">
      {tabList.map((tab, index) => {
        const isActive = index === currentTab;

        return (
          <button
            key={tab.key}
            className={`circle-tab ${isActive ? "is-active" : ""}`}
            onClick={() => {
              setCurrentTab(index);
              onChange?.(tab.key, tab.label);
            }}
            role="tab"
            aria-selected={isActive}
            type="button"
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default AnalysisTabsComponent;
